import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-login-banner',
    templateUrl: './login-banner.component.html',
    styleUrls: ['./login-banner.component.scss'],
    imports: [
    ]
})
export class LoginBannerComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
